/**
 * Generato automaticamente.
 * framework-monitoraggio-eventi
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type { TipoRecordDTO } from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Cerca uno o più ruoli utente
 * @summary Cerca ruoli utente
 */
export const getTipoRecord = (
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<TipoRecordDTO[]>(
    {
      url: `/framework-monitoraggio-eventi/tipo-record`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetTipoRecordQueryKey = () =>
  [`/framework-monitoraggio-eventi/tipo-record`] as const;

export const getGetTipoRecordQueryOptions = <
  TData = Awaited<ReturnType<typeof getTipoRecord>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getTipoRecord>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryOptions<
  Awaited<ReturnType<typeof getTipoRecord>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTipoRecordQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTipoRecord>>> = ({
    signal,
  }) => getTipoRecord(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetTipoRecordQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTipoRecord>>
>;
export type GetTipoRecordQueryError = ErrorType<unknown>;

/**
 * @summary Cerca ruoli utente
 */
export const useGetTipoRecord = <
  TData = Awaited<ReturnType<typeof getTipoRecord>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getTipoRecord>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTipoRecordQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
